
import { reducerConstants } from "../../../constants/reducer-constant";
import { INITIAL_STATE as partnerFormReducerInitialState, HANDLERS as partnerFormReducerHandler } from "../../../components/desktop/become-our-partner-form/reducers";

export default {
    [reducerConstants.PARTNER_FORM]: { state: partnerFormReducerInitialState, handler: partnerFormReducerHandler }
};
